import React, { Component } from "react";
import ApprovalFlow from "../../../components/ApprovalFlow/ApprovalFlow";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ApprovalFlowForm
Description : Componente que invoca al componente ApprovalFlow.
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class ApprovalFlowForm extends Component {
    render() {
        return (
            <ApprovalFlow />
        )
    }
}

export default ApprovalFlowForm;